import { jsx as _jsx } from "react/jsx-runtime";
import { getTiposAtendimentos } from './tipos_atendimentos.service';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 500 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export function TiposAtendimentosListar() {
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_ATENDIMENTOS, paginaPermissao: FUNCIONALIDADES.TIPOS_ATENDIMENTOS, rota: ROUTES.TIPOS_ATENDIMENTOS, fetchData: function (str, _filter, pag) { return getTiposAtendimentos(str, pag); }, columns: COLUNAS }));
}
export default TiposAtendimentosListar;
